import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Done as DoneIcon, Info as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { CircularProgress as CircularProgressStyled, CircularProgressPending } from './CircularProgress.style';
export function CircularProgress({ status }) {
    return (_jsxs(Box, Object.assign({ sx: {
            display: 'grid',
            position: 'relative',
            placeItems: 'center',
        } }, { children: [_jsx(CircularProgressStyled, { variant: "determinate", status: status, size: 32, thickness: 3, value: 100 }), status === 'STARTED' || status === 'PENDING' ? (_jsx(CircularProgressPending, { size: 32, thickness: 3 })) : null, status === 'ACTION_REQUIRED' ? (_jsx(InfoIcon, { color: "info", sx: {
                    position: 'absolute',
                    fontSize: '1rem',
                } })) : null, status === 'DONE' ? (_jsx(DoneIcon, { color: "success", sx: {
                    position: 'absolute',
                    fontSize: '1rem',
                } })) : null, status === 'FAILED' ? (_jsx(WarningIcon, { color: "error", sx: {
                    position: 'absolute',
                    fontSize: '1rem',
                } })) : null] })));
}
